// extracted by mini-css-extract-plugin
export default {"root":"zY2Si__root"};